export default $axios => () => ({
    async get() {
        let response = await $axios.$get(`/api/v1/premium-paraphraser`);
        return response.data;
    },
});
